import type { FaireProductEntity } from "../../entity_types/product";

export const p_a5ck3fb4pf: FaireProductEntity = {
  token: "p_a5ck3fb4pf",
  type: "product",
  name: "Wow Thanks Cowboy Card",
  brandToken: "b_vup8x6ncrs",
  brandName: "Studio Conroy",
  imageUrl:
    "https://cdn.faire.com/fastly/9ee55bbda1907fe463ff7f0921f1c61e0eeb48255f7b847e97c1a0a46dd8f85e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/037aebe1e31bffbd0ff4a7cb854598a4a91cd935f7818cd576e331467f45af22.png",
  ],
  priceDollars: 2.75,
  description:
    "• A2 (4.25 x 5.5\")\n• Blank inside so you can write your own special message.\n• Comes with a white envelope and protective cellophane sleeve.\n• We love imperfections! If you see a speckle or a dot, it's because these cards are printed on 100% recycled paper.\n• Made in California.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:53.479Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
